module.exports = __webpack_public_path__ + "static/media/img.preview3.2e00674e.svg";